import { createAction } from 'lib/store-utils';
import { RosterTimesheetListedWithPayEntries } from 'type';

export const BOX_TIMESHEET_RESPONSE_TIMESHEET_CHANGED = createAction<RosterTimesheetListedWithPayEntries>('Timesheet response / timesheet changed');
export const BOX_TIMESHEET_RESPONSE_TIMESHEET_DELETED = createAction<{ id: string }>('Timesheet response / timesheet deleted');
